import { areaSection, imagerySection, mapsSection, transectSections } from '../utils/transectReportSections';

/**
 * Describes a shoreline evolution analysis as a document.
 * What this module measures - rates of change along transects, classified by Esteves - is what
 * Shore-R measures too, so the sections come from {@link module:TRANSECT_REPORT_SECTIONS} and only
 * the title and the coastline count are particular to here.
 */

/**
 * @constant REPORT_MODULE
 * @description Module key, used to name the file and to register the export.
 * @memberof module:Shoreline
 */
export const REPORT_MODULE = 'shoreline';

/**
 * @function buildShorelineReport
 * @description The whole document, as data.
 * @param {Object} params
 * @param {Array<Array<Number>>} [params.coordinates] - Area of interest ring.
 * @param {Array<Array<Number>>} [params.baselineCoords] - Baseline vertices.
 * @param {Array<Object>} [params.transectData] - The analysed transects.
 * @param {Object} [params.shorelineFeatures] - The extracted coastlines.
 * @param {Array<Object>} [params.images] - Already loaded by {@link loadImageForReport}.
 * @param {Object} params.text - Every piece of wording, already translated.
 * @param {Function} [params.className] - Translates an Esteves class for the reader.
 * **Called by:
 * @see {CoastlineEvolutionDialog}
 * @memberof module:Shoreline
 * @returns {Object} A document description for {@link renderReport}.
 */
export const buildShorelineReport = ({
  coordinates,
  baselineCoords,
  transectData,
  shorelineFeatures,
  chosenImages,
  satellite,
  kmlFileName,
  images,
  text,
  className,
}) => {
  const coastlines = shorelineFeatures?.features?.length ?? shorelineFeatures?.length ?? null;
  const imagery = imagerySection({ images: chosenImages, satellite, text });

  return {
    title: text.title,
    subtitle: text.subtitle,
    footer: text.footer,
    missingImageNote: text.missingImage,
    sections: [
      areaSection({ coordinates, baselineCoords, kmlFileName, text }),
      { ...imagery, rows: [...imagery.rows, [text.coastlines, coastlines]] },
      ...transectSections({ transects: transectData, text, className }),
      mapsSection({ images, text }),
    ],
  };
};
